import { useEffect, useState } from "react";
import { Phone, Menu, X } from "lucide-react";
import { SITE, NAV_LINKS } from "../../data/site";

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 inset-x-0 z-40 transition-all duration-300 ${
        scrolled
          ? "bg-[#F9F7F4]/85 backdrop-blur-xl border-b border-[#E5DFD5]"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3 group" data-testid="brand-link">
          <span className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center bg-[#1E2C25] text-[#C05746] font-display text-lg leading-none">
            A
          </span>
          <span className="font-display text-[#1C1B1A] tracking-tight text-sm md:text-base">
            ATC <span className="text-[#5C5A55] font-medium">Pest Control</span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-10">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-sm uppercase tracking-[0.18em] text-[#1C1B1A] link-underline"
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={SITE.phoneHref}
            data-testid="nav-call-button"
            className="cta-shimmer hidden sm:inline-flex items-center gap-2 bg-[#C05746] hover:bg-[#A64B3C] text-[#F9F7F4] px-5 py-3 font-semibold text-sm uppercase tracking-[0.12em] transition-colors"
          >
            <Phone size={16} strokeWidth={2.5} />
            {SITE.phoneDisplay}
          </a>
          <button
            onClick={() => setOpen((v) => !v)}
            aria-label="Toggle menu"
            data-testid="nav-mobile-toggle"
            className="lg:hidden p-2 text-[#1C1B1A]"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-[#F9F7F4] border-t border-[#E5DFD5]" data-testid="nav-mobile-panel">
          <div className="px-6 py-8 flex flex-col gap-5">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-base uppercase tracking-[0.18em] text-[#1C1B1A]"
              >
                {l.label}
              </a>
            ))}
            <a
              href={SITE.phoneHref}
              className="mt-2 inline-flex items-center gap-2 bg-[#C05746] text-[#F9F7F4] px-5 py-4 font-semibold text-sm uppercase tracking-[0.12em] w-fit"
            >
              <Phone size={16} /> Call {SITE.phoneDisplay}
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
